export default function Cases() {
  return (
    <section id="cases" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            CASE STUDIES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            不用品回収の<span className="text-primary-500">作業事例</span>
          </h2>
        </div>

        <div className="rounded-lg border border-dashed border-background-300 bg-background-100 p-10 md:p-16 text-center">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-6">
            <i className="ri-gallery-line text-3xl text-secondary-700"></i>
          </div>
          <p className="text-foreground-700 font-bold text-base md:text-lg mb-3">
            実際の施工事例を準備中です
          </p>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-xl mx-auto">
            京都での不用品回収・粗大ゴミ処分の実際の作業事例を、順次掲載してまいります。
            <br className="hidden md:block" />
            掲載まで今しばらくお待ちください。
          </p>
        </div>
      </div>
    </section>
  );
}